import './Hero.scss';
import coverHeader from '../assets/coverHeader.jpg';
import cvFile from '../assets/curriculum-vitae-fabien-bazire.pdf';

const Hero = () => (
  <section className="hero" id="hero">
    <img src={coverHeader} alt="" className="hero__bg" aria-hidden="true" />
    <div className="hero__content">
      <p className="hero__tag">Direction Artistique · DA Senior · Freelance depuis 2008</p>
      <h1 className="hero__title">
        DESIGN<br />
        QUI<br />
        CONNECTE.
      </h1>
      <p className="hero__sub">Bienvenue sur mon portfolio</p>
    </div>

    <div className="hero__sections">
      <a href="#works" className="hero__section-link">
        <span className="hero__section-num">01</span>
        <span className="hero__section-line"></span>
        <span className="hero__section-text">Mon Travail</span>
      </a>
      <a href="#about" className="hero__section-link">
        <span className="hero__section-num">02</span>
        <span className="hero__section-line"></span>
        <span className="hero__section-text">Me Connaître</span>
      </a>
      <a href="#approach" className="hero__section-link">
        <span className="hero__section-num">03</span>
        <span className="hero__section-line"></span>
        <span className="hero__section-text">Mon Approche</span>
      </a>
      <a href="#contact" className="hero__section-link">
        <span className="hero__section-num">04</span>
        <span className="hero__section-line"></span>
        <span className="hero__section-text">Contact</span>
      </a>
    </div>

    <a href="#works" className="hero__scroll">
      <div className="hero__scroll-icon">
        <span></span>
      </div>
      <span className="hero__cta">VOIR MON TRAVAIL</span>
    </a>

    <div className="hero__meta-right">
      <a href="https://www.linkedin.com/in/fabien-bazire/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      </a>
      <a href="mailto:bazire.fabien@gmail.com" aria-label="Email">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="4" width="20" height="16" rx="2"/>
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
        </svg>
      </a>
      <a href="tel:+33650393728" aria-label="Téléphone">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6.06 6.06l.92-.92a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.02z"/>
        </svg>
      </a>
      <a href={cvFile} download="CV-Fabien-Bazire.pdf" aria-label="Télécharger mon CV">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="12" y1="12" x2="12" y2="18"/>
          <polyline points="9 15 12 18 15 15"/>
        </svg>
      </a>
    </div>
  </section>
);

export default Hero;
